import React, { FC } from "react";

export type TPositiveIconProps = React.SVGAttributes<SVGElement>;

const PositiveIcon: FC<TPositiveIconProps> = ({ ...rest }) => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" {...rest}>
      <rect width="32" height="32" rx="16" fill="#21BE6B" />
      <path fillRule="evenodd" clipRule="evenodd" d="M24.2071 11.7072L14 21.9143L8.29285 
      16.2072L9.70706 14.793L14 19.0859L22.7928 10.293L24.2071 11.7072Z" fill="white" />
    </svg>
  );
}

export default PositiveIcon;
